(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mockup-usps"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  console.log('Script loaded');
  
  document.documentElement.classList.add('js-enabled');
  
  const mockups = document.querySelectorAll('#mobile-features-section .mobile-feature-item');
  
  
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  
  if (!prefersReducedMotion) {
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate');
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });
    
    mockups.forEach((mockup, index) => {
      observer.observe(mockup);
    });
  } else {
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-thumbs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const playButtons = document.querySelectorAll('.video-play-btn');
  
  playButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const videoUrl = this.getAttribute('data-video-url');
      const videoName = this.getAttribute('data-video-name');
      if (!videoUrl) return;
       window.posthog.capture('Played Feature Video', {
         'Video': videoName,
         'Video URL': videoUrl
        });
      // Create modal
      const modal = document.createElement('div');
      modal.className = 'video-modal';
      
      const modalContent = document.createElement('div');
      modalContent.className = 'video-modal-content';
      
      const closeButton = document.createElement('button');
      closeButton.className = 'video-modal-close';
      closeButton.innerHTML = '×';
      closeButton.setAttribute('aria-label', 'Close video');
      
      let videoElement;
      
      // Handle different video types
      if (videoUrl.includes('youtube.com') || videoUrl.includes('youtu.be')) {
        let videoId = '';
        if (videoUrl.includes('watch?v=')) {
          videoId = videoUrl.split('v=')[1].split('&')[0];
        } else if (videoUrl.includes('youtu.be/')) {
          videoId = videoUrl.split('youtu.be/')[1].split('?')[0];
        }
        
        videoElement = document.createElement('iframe');
        videoElement.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
        videoElement.allow = 'autoplay; encrypted-media';
        videoElement.allowFullscreen = true;
        videoElement.frameBorder = '0';
        
      } else if (videoUrl.includes('vimeo.com')) {
        const videoId = videoUrl.split('vimeo.com/')[1].split('?')[0];
        videoElement = document.createElement('iframe');
        videoElement.src = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
        videoElement.allow = 'autoplay; fullscreen';
        videoElement.allowFullscreen = true;
        videoElement.frameBorder = '0';
        
      } else if (videoUrl.match(/\.(mp4|webm|ogg|mov)(\?|$)/i)) {
        videoElement = document.createElement('video');
        videoElement.src = videoUrl;
        videoElement.controls = true;
        videoElement.autoplay = true;
        videoElement.preload = 'metadata';
        
      } else {
        // Fallback: open in new tab
        window.open(videoUrl, '_blank', 'noopener,noreferrer');
        return;
      }
      
      modalContent.appendChild(closeButton);
      modalContent.appendChild(videoElement);
      modal.appendChild(modalContent);
      document.body.appendChild(modal);
      
      // Prevent body scroll
      document.body.style.overflow = 'hidden';
      
      // Show modal with animation
      requestAnimationFrame(() => {
        modal.classList.add('active');
      });
      
      // Close handlers
      const closeModal = () => {
        modal.classList.remove('active');
        setTimeout(() => {
          if (document.body.contains(modal)) {
            document.body.removeChild(modal);
            document.body.style.overflow = '';
          }
        }, 300);
      };
      
      closeButton.addEventListener('click', closeModal);
      modal.addEventListener('click', (e) => {
        if (e.target === modal) closeModal();
      });
      
      // Close on escape
      const handleEscape = (e) => {
        if (e.key === 'Escape') {
          closeModal();
          document.removeEventListener('keydown', handleEscape);
        }
      };
      document.addEventListener('keydown', handleEscape);
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
